import { render, staticRenderFns } from "./FormulaFieldConfigurator.vue?vue&type=template&id=f24b41ca"
import script from "./FormulaFieldConfigurator.vue?vue&type=script&lang=js"
export * from "./FormulaFieldConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports